export function buildAttrStackOption(payload, attr, hiColor, topN = 15) {
    if (!payload?.dataset?.rows?.length) {
        return { title: { text: 'No data' } }
    }

    // --- column indexes -------------------------------------------------
    const idx = payload.dataset.columns.reduce((m, c, i) => {
        m[c.columnName] = i
        return m
    }, {})

    // --- group rows by category ----------------------------------------
    const map = new Map() // eventType -> { in:0, out:0 }
    const clean = (s) => (typeof s === 'string' ? s.replace(/^\d{1,2}:\s?/, '') : s)

    for (const row of payload.dataset.rows) {
        const cat = clean(row[idx[attr]])
        const inSeg = row[idx.In] === '1'
        const cnt = parseInt(String(row[idx.Count]).replace(/,/g, ''), 10)

        const o = map.get(cat) || { in: 0, out: 0 }
        inSeg ? (o.in += cnt) : (o.out += cnt)
        map.set(cat, o)
    }

    // --- respect server order, slice topN ------------------------------
    const cats = [],
        inArr = [],
        outArr = []
    let n = 0

    for (const row of payload.dataset.rows) {
        const cat = clean(row[idx[attr]])

        if (map.has(cat) && !cats.includes(cat)) {
            cats.push(cat)
            inArr.push(map.get(cat).in)
            outArr.push(map.get(cat).out)
            if (++n >= topN) break
        }
    }
    if (cats.length === 1 && !cats[0]) {
        cats[0] = 'Count'
    }

    return {
        grid: { left: 20, right: 20, top: 5, bottom: 0, containLabel: true },

        yAxis: {
            type: 'category',
            inverse: true,
            data: cats,
            axisLabel: { fontSize: 10, overflow: 'truncate', width: 140 },
        },

        xAxis: {
            type: 'value',
            splitLine: { show: false },
            axisLabel: { formatter: '{value}' },
        },

        tooltip: {
            trigger: 'axis',
            axisPointer: { type: 'shadow' },
            formatter: (p) => {
                const i = p[0].dataIndex
                return (
                    `${cats[i]}<br/>` +
                    `In segment: ${(inArr[i] ?? 0).toLocaleString()}<br/>` +
                    `Rest: ${(outArr[i] ?? 0).toLocaleString()}`
                )
            },
        },

        series: [
            {
                name: 'In segment',
                type: 'bar',
                stack: 'total',
                data: inArr,
                itemStyle: { color: hiColor },
            },
            {
                name: 'Rest',
                type: 'bar',
                stack: 'total',
                data: outArr,
                itemStyle: { color: '#d1d5db' },
            },
        ],

        animationDuration: 300,
    }
}
